import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { products } from '../../data/products';
export function IngredientMarquee() {
  const reduce = useReducedMotion();
  const names = products.filter(p => p.category !== 'sets').map(p => p.name);
  const row = [...names, ...names];
  return <div className="overflow-hidden bg-pink py-5 text-white" aria-hidden="true" data-id="element-79" data-mp="1b08w8zkcvpt7">
      <motion.ul className="flex w-max items-center gap-8 whitespace-nowrap" animate={reduce ? undefined : {
      x: ['0%', '-50%']
    }} transition={{
      duration: 45,
      ease: 'linear',
      repeat: Infinity
    }} data-id="element-80" data-mp="1fzljvmj1x0wu">
        {row.map((n, i) => <li key={i} className="flex items-center gap-8 font-display text-2xl uppercase tracking-display sm:text-3xl" data-id="element-81" data-mp="1os5jap7639iq" data-mpi={i}>
            {n}
            <span className="h-2 w-2 rotate-45 bg-blush" data-id="element-82" data-mp="1yptipsfpx578" />
          </li>)}
      </motion.ul>
    </div>;
}